import { ContactItem } from "@/components/Pages/ContactPage";
import { Enquiry } from "@/components/Pages/ContactPage";
import Banner from "@/components/Shares/Banner";
import Breadcrumb from "@/components/Shares/Breadcrumb";
import Head from "next/head";
import { contact } from "@/data/contact";
import Link from "next/link";
import { Button } from "@nextui-org/react";
import { IoMdChatboxes } from "react-icons/io";
import SEOHead from "@/components/Shares/SEOHead/SEOHead";
import BreadcrumbSchema from "@/components/Shares/StructuredData/BreadcrumbSchema";

export default function Contact() {
  return (
    <>
      <SEOHead
        title="Contact Us"
        description="Get in touch with Priceworth Furniture. Contact us for inquiries, support, and more. We're here to help you with all your furniture needs."
        canonical="https://www.priceworth.com.au/contact"
        keywords="contact Priceworth Furniture, furniture customer service, furniture support, furniture inquiries, furniture store contact"
        ogType="website"
      />
      <BreadcrumbSchema
        items={[
          { label: "Home", link: "/" },
          { label: "Contact Us", link: "/contact" }
        ]}
      />
      <Banner
        title="Contact us"
        small="Our sales team will be with you soon!"
      />
      <div className="container">
        <Breadcrumb pages={[{ label: "contact us", link: "/contact" }]} />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 pb-12">
          {contact.map((item, index) => {
            const { name, street, city, email, phone, assistanceHours } = item;
            return (
              <ContactItem
                key={index}
                name={name}
                street={street}
                city={city}
                email={email}
                phone={phone}
                assistanceHours={assistanceHours}
              />
            );
          })}
        </div>
        <div className="border-t py-12">
          <IoMdChatboxes className="text-6xl" />
          <h2 className="text-lg font-semibold my-6">Shop by chat</h2>
          <p className="mb-6">
            Contact us via chat between 8 am – 6 pm (AEST) to make your purchase
            or ask our specialists any questions you have.
          </p>
          <Link href="javascript:void(Tawk_API.toggle())">
            <Button className="text-white text-sm rounded-md px-4 flex items-center bg-icon transition-all duration-500">
              Start chat
            </Button>
          </Link>
        </div>
        <Enquiry />
      </div>
    </>
  );
}
